import { useState, useEffect } from 'react';
import { supabase } from './supabaseClient';
import { Exam, Topic, Question } from './examData';

interface ExamRow {
    id: string;
    course_id: string;
    title: string;
    semester: string;
    year: number;
    questions: QuestionRow[];
}

interface QuestionRow {
    id: number;
    exam_id: string;
    question_num: number;
    sub: string | null;
    text: string;
    choices: string[];
    correct_index: number;
    points: number;
    topic_ids: string[];
    source_exam: string | null;
    image: string | null;
    free_response: boolean;
    explanations: string[] | null;
}

function mapQuestion(row: QuestionRow): Question {
    return {
        id: row.question_num,
        sub: row.sub || undefined,
        text: row.text,
        choices: row.choices,
        correctIndex: row.correct_index,
        points: row.points,
        topics: row.topic_ids,
        sourceExam: row.source_exam || undefined,
        image: row.image || undefined,
        freeResponse: row.free_response || undefined,
        explanations: row.explanations || undefined,
    };
}

function mapExam(row: ExamRow): Exam {
    return {
        id: row.id,
        courseId: row.course_id,
        title: row.title,
        semester: row.semester,
        year: row.year,
        questions: (row.questions || []).map(mapQuestion),
    };
}

export function useExamData() {
    const [exams, setExams] = useState<Exam[]>([]);
    const [topics, setTopics] = useState<Topic[]>([]);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        async function fetchData() {
            const [examsRes, topicsRes] = await Promise.all([
                supabase.from('exams').select('*, questions(*)').order('year', { ascending: false }),
                supabase.from('topics').select('*'),
            ]);

            if (examsRes.data) {
                setExams(examsRes.data.map(mapExam));
            }
            if (topicsRes.data) {
                setTopics(topicsRes.data);
            }
            setLoading(false);
        }
        fetchData();
    }, []);

    return { exams, topics, loading };
}
